import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
  url: process.env.BUN_PUBLIC_KEYCLOAK_URL ?? "https://keycloak.mesta.io",
  realm: process.env.BUN_PUBLIC_KEYCLOAK_REALM ?? "carton-plein",
  clientId: process.env.BUN_PUBLIC_KEYCLOAK_CLIENT_ID ?? "carton-plein-client",
});

export default keycloak;
